export default function formatText(text) {
  return text.replace(/\n/g, '<br>');
}
